const ErrorType = {
    MANDATORY: "MANDATORY",
    INVALID_FORMAT: "INVALID_FORMAT"
};

export default ErrorType;
